import React from 'react';
import { PriceTableValueDisplay } from './PriceTableValueDisplay';

export interface IPricingTableItem {
    label: string;
    itemKey: string;
}

export const PricingTableItem: React.FC<IPricingTableItem> = (props) => {
    const { label, itemKey } = props;

    return (
        <div className="relative grid grid-cols-[30%,2fr,2fr,2fr] gap-2 border-b border-neutral-700 py-2 md:grid-cols-[50%,2fr,2fr,2fr]">
            <div className="flex items-center font-bold text-xs text-neutral-50 md:text-xl">
                {label}
            </div>
            <div className="flex items-center justify-center">
                <PriceTableValueDisplay itemKey={itemKey} tierNo={1} />
            </div>
            <div className="flex items-center justify-center">
                <PriceTableValueDisplay itemKey={itemKey} tierNo={2} />
            </div>
            <div className="flex items-center justify-center">
                <PriceTableValueDisplay itemKey={itemKey} tierNo={3} />
            </div>
        </div>
    );
};
